import { getAuthCode } from "./getAuthCode";
export const editIdea = async (id,newContent) => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL + "/editIdea";
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode(),"id" : id,newContent:newContent})
      });
      const result = await response.json();
      return result.message
    } catch (error) {
      console.log(error);
    }
  };